<template>
  <div class="lh-box" :class="videoOn">
  	<div class="lh-page lh-page1 cover" style="background-image:url(style/img/main/main.png);">     
        <div class="lh-return" data-type="return" data-path="/" @click="gotoNext($event)"><img src="style/img/return.png" /></div>
		<ul class="lh-main-item l-grid-3">
	        <li v-for="(item,index) in btn" :data-idx="index" :data-path="item.path" :data-type="item.type" @click="clickBtn($event)" :class="item.hover">
	            <div class="img"><img src="style/img/main/box1.png?a=1" /></div>
	            <div class="img1"><img :src="item.icon" /></div>
	            <div class="text"><img :src="item.text" /></div>
	        </li>
	    </ul>
	    <div class="lh-start" :data-idx="start.idx" :data-path="start.path" :data-type="start.type" @click="clickBtn($event)"><img src="style/img/main/start.png" /></div>
	    <div class="lh-main-audio">
	    	<audio id="audioMain" loop src="style/img/main/sound/main_music.mp3"></audio>
	        <audio id="audioMainButton" src="style/img/main/sound/main_button.mp3"></audio>
	    </div>
	</div>
	<!--加载动画-->
	<div class="lh-loading-new story">
		<audio id="loadingAudio" src="style/img/loading/anisound.mp3"></audio>
		<div style="background-image:url(style/img/loading/story.png)"></div>
	</div>
	<!--video-->
	<div class="lh-video">
		<a href="javascript:;" class="lh-video-return" @click="closeVideo($event)"><i class="iconfont iconfont icon-xiangzuo"></i></a>
	    <video src="style/img/video/video_x264.mp4" controls playsinline="true" webkit-playsinline="true" controlslist="nofullscreen nodownload"></video>
	</div>
	<div class="lh-prefetch">
      <link rel="prefetch" href="style/img/learning/bg.jpg">
      <link rel="prefetch" href="style/img/learning/a1.png">
      <link rel="prefetch" href="style/img/learning/a2.png">
      <link rel="prefetch" href="style/img/learning/a3.png">
      <link rel="prefetch" href="style/img/learning/a4.png?a=2">
      <link rel="prefetch" href="style/img/learning/slide.png">
      <link rel="prefetch" href="style/img/learning/sound/ep1_LT_1.mp3">
      <link rel="prefetch" href="style/img/learning/sound/slide_sound.mp3">
      <link rel="prefetch" href="style/img/learning/sound/slide.mp3?a=1">
      <!--checking-->
      <link rel="prefetch" href="style/img/checking/checking4-bd.png">
      <link rel="prefetch" href="style/img/checking/checking-text-bg.png">
      <link rel="prefetch" href="style/img/checking/checking-text1.png">
      <link rel="prefetch" href="style/img/checking/checking4-bg.png">
      <link rel="prefetch" href="style/img/checking/checking4.png">
      <link rel="prefetch" href="style/img/checking/checking1-bg.png">
      <link rel="prefetch" href="style/img/checking/checking1.png">
      <link rel="prefetch" href="style/img/checking/checking3-bg.png">
      <link rel="prefetch" href="style/img/checking/checking3.png">
      <link rel="prefetch" href="style/img/checking/checking2-bg.png">
      <link rel="prefetch" href="style/img/checking/checking2.png">
      <link rel="prefetch" href="style/img/checking/checking2-bg.png">
      <link rel="prefetch" href="style/img/checking/checking2-bg.png">
      <link rel="prefetch" href="style/img/checking/checking2-bg.png">
      <link rel="prefetch" href="style/img/checking/sound/ep1-checking-time.mp3">
      <link rel="prefetch" href="style/img/checking/sound/ep1_CT_1.mp3">
      <link rel="prefetch" href="style/img/checking/sound/ep1_CT_2.mp3">
      <link rel="prefetch" href="style/img/learning/sound/slide.mp3">
      <!--practicing-->
      <link rel="prefetch" href="style/img/practicing/swing.png">
      <link rel="prefetch" href="style/img/practicing/swing-text.png?a=1">
      <link rel="prefetch" href="style/img/practicing/slide.png">
      <link rel="prefetch" href="style/img/practicing/slide-text.png?a=1">
      <link rel="prefetch" href="style/img/practicing/seesaw.png?a=1">
      <link rel="prefetch" href="style/img/practicing/seesaw-text.png?a=1">
      <link rel="prefetch" href="style/img/practicing/roundabout.png">
      <link rel="prefetch" href="style/img/practicing/roundabout-text.png?a=1">
      <link rel="prefetch" href="style/img/learning/sound/ep1-practice-time.mp3">
      <!--writing-->
      <link rel="prefetch" href="style/img/writing/slide-icon.png">
      <link rel="prefetch" href="style/img/writing/writing-bg.png">
    </div>
  </div>
</template>
<script>
export default{
	data(){
		return {
			videoOn:'',
			btn:[
				{icon:'style/img/main/04.png?a=1',text:'style/img/main/box-text1.png?a=1',path:'',type:'layer',hover:''},
				{icon:'style/img/main/02.png?a=1',text:'style/img/main/box-text2.png?a=1',path:'/slide',type:'',hover:''},
				{icon:'style/img/main/01.png?a=1',text:'style/img/main/box-text3.png?a=1',path:'/checking',type:'',hover:''},
				{icon:'style/img/main/03.png?a=1',text:'style/img/main/box-text4.png?a=1',path:'/practicing',type:'',hover:''},
				{icon:'style/img/main/05.png?a=1',text:'style/img/main/box-text5.png?a=1',path:'/writing',type:'',hover:''}
			],
			start:{idx:0,path:'',type:'layer'}
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
		var that=this;
		$('#audioMain')[0].play();
		document.addEventListener("WeixinJSBridgeReady", function () {//微信
           $('#audioMain')[0].play();
           $('#audioMainButton')[0].load();
        }, false);
		var start=JSON.parse(sessionStorage.getItem("start"));
	    if(start){
	        that.start=start;  
	    } 
	},
	methods:{
		gotoNext(e){
			var that=this,path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path})
		},
		clickBtn(e){
			var that=this,path=$(e.currentTarget).data('path'),type=$(e.currentTarget).data('type'),idx=$(e.currentTarget).data('idx'),btn=that.btn;
			for(var i=0;i<btn.length;i++){
				btn[i].hover="";
			}
			that.btnShow(idx);
			$('#audioMainButton')[0].addEventListener("ended",function(){
				if(type=='layer'){//视频弹窗
					that.videoOn="openVideo";
					$('#loadingAudio')[0].play();
					setTimeout(function(){
						$('.lh-loading-new>div').css({'animation-play-state':'paused'});
					},1000);
					setTimeout(function(){
						$('.lh-loading-new>div').css({'animation-play-state':'running'});
					},2000);
					setTimeout(function(){
						$('.lh-video').show();
						$('.lh-video video')[0].play();
						that.endVideo(idx,$('.lh-video video')[0]);
					},2500)
				}else{
					that.$router.replace({ path: path});
				} 
			 })
			// setTimeout(function(){
			// 	if(type=='layer'){//视频弹窗
			// 		that.videoOn="openVideo";
			// 		$('#loadingAudio')[0].play();
			// 		setTimeout(function(){
			// 			$('.lh-loading-new>div').css({'animation-play-state':'paused'});
			// 		},1000);
			// 		setTimeout(function(){
			// 			$('.lh-loading-new>div').css({'animation-play-state':'running'});
			// 		},2000);
			// 		setTimeout(function(){
			// 			$('.lh-video').show();
			// 			$('.lh-video video')[0].play();
			// 			that.endVideo(idx,$('.lh-video video')[0]);
			// 		},2500)
			// 	}else{
			// 		that.$router.replace({ path: path});
			// 	}
			// },650);
		},
		//按钮效果
		btnShow(idx){
			$('#audioMainButton')[0].play();
			$('#audioMain')[0].pause();
			this.btn[idx].hover="hover";
		},
		//关闭视频
		closeVideo(e){
			this.videoOn="";
			$('.lh-video').hide();
			$('.lh-video video')[0].pause();
			$('#audioMain')[0].play();
		},
		//视频播放结束
		endVideo(idx,e){
			var that=this;
			e.addEventListener("ended",function(){
				 that.btn[idx].hover="";
				 that.videoOn="";
				 $('#audioMain')[0].play();
			 })
		}
	}
}
</script>
